import { render, staticRenderFns } from "./TouchKey.vue?vue&type=template&id=ae90d1e2&"
import script from "./TouchKey.vue?vue&type=script&lang=js&"
export * from "./TouchKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports